import React, {CSSProperties, KeyboardEvent, MouseEvent} from "react"

import classNames from "classnames";
import styles from '../css/App.module.css'
import {rem} from "../utils/CSSUtils";

export interface Props {
    direction?: Direction,
    center?: boolean,
    shrink?: boolean,
    grow?: boolean,
    top?: boolean,
    line?: boolean,
    space?: boolean,
    xsSpace?: boolean,
    flex?: boolean,
    fullWidth?: boolean,
    bottom?: boolean,
    spaceBetween?: boolean,
    sideMargin?: boolean,
    children?: React.ReactNode,
    style?: CSSProperties,
    topMargin?: number,
    bottomMargin?: number,
    onClick?: (event: MouseEvent) => void,
    leftMargin?: number,
    rightMargin?: number
    className?: string
    onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void
}

export enum Direction {
    ROW,
    Column,
    Clear
}

const DirectionStyles = [
    styles.row,
    styles.column,
    ""
];

export default (props: Props) => {
    const {
        children,
        line,
        direction = Direction.ROW,
        bottom,
        space,
        spaceBetween,
        sideMargin,
        xsSpace,
        center,
        top,
        shrink,
        grow,
        style = {},
        topMargin,
        bottomMargin,
        leftMargin,
        rightMargin,
        onKeyDown,
        onClick,
        className,
        flex,
        fullWidth
    } = props;

    if (topMargin != null || bottomMargin != null || leftMargin != null || rightMargin != null) {
        style.marginLeft = rem(leftMargin) || style.marginLeft;
        style.marginTop = rem(topMargin) || style.marginTop;
        style.marginBottom = rem(bottomMargin) || style.marginBottom;
        style.marginRight = rem(rightMargin) || style.marginRight;
    }

    return (
        <div onKeyDown={onKeyDown} onClick={onClick} style={style} className={classNames(DirectionStyles[direction], {
            [styles.rowTop]: top,
            [styles.rowCenter]: center,
            [styles.shrink]: shrink,
            [styles.grow]: grow,
            [styles.boxFlex]: flex,
            [styles.boxFullWidth]: fullWidth,
            [styles.shrink]: shrink || line,
            [styles.rowSpace]: space,
            [styles.rowXsSpace]: xsSpace,
            [styles.rowBottom]: bottom,
            [styles.columnSpaceBetween]: spaceBetween,
            [styles.line]: line,
            [styles.sideMargin]: sideMargin,
        }, className)}>
            {children}
        </div>
    )
}
